module.exports = __webpack_public_path__ + "media/images/common-nav/rv-parks/oregon-b02c3899be1c1e4e84def90dc7c37a37.jpg";